import styled from 'styled-components';
import { vw } from 'components/common/Common';
import { H1, P, Link } from '../JetCard.style';

const JetCardHeader = styled.div`
  width: 100%;
  height: fit-content;
`;

const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  padding: ${vw(150)} ${vw(80)} ${vw(80)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const Left = styled.div`
  max-width: 662px;
`;

const Right = styled.div`
  max-width: ${vw(420)};
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${vw(30)};

  p {
    color: #424748;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.3;
    margin: 0;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  a {
    width: 180px;
    border: none;
    background-color: #1f68db;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: ${vw(12)} 0;
    border-radius: ${vw(4)};
    text-decoration: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`;

const Header = () => {
  return (
    <JetCardHeader>
      <Content>
        <Left>
          <H1>Airacer Preferred Jet Card Membership</H1>
        </Left>
        <Right>
          <P>
            Elevate your travel experience with the Airacer Jet Card Membership —your ticket to
            private aviation.
          </P>
          <ButtonContainer>
            <Link href="/contactUs">Contact us</Link>
          </ButtonContainer>
        </Right>
      </Content>
    </JetCardHeader>
  );
};

export default Header;
